import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "聊天会话", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "联系人", -1)

import {
    ChatRound,
    Avatar,
    Switch,
    User,
} from '@element-plus/icons-vue';
import { useStore } from "vuex";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import { WeChatMutations, WeChatGetters, WeChatActions } from "@/store/modules/weChat";
import { WeChatContact } from '@/store/modules/weChat/types';


import { defineComponent } from "vue";

const __default__ = defineComponent({
    name: "WeChatMenu",
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const route = useRoute();
const store = useStore();
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const wechatIdCom = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getMeId}`];
});

const changeWeChatIdDialog = ref<boolean>(false)

const selectMenu = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getSelectMenu}`];
});

const idList = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getIdList}`];
});

const handleClick = (key: string) => {
    if (key !== "3") {
        store.commit(`weChat/${WeChatMutations.setSelectedSession}`, null);
        store.commit(`weChat/${WeChatMutations.setSelectMenu}`, key);
    } else {
        changeWeChatIdDialog.value = true
    }
}

const handleChooseId = async (selectedUser: WeChatContact) => {
    const projid = projectId.value
    const uid = targetId.value
    changeWeChatIdDialog.value = false

    store.commit(`weChat/${WeChatMutations.resetAll}`);
    store.commit(`weChat/${WeChatMutations.setSelectMenu}`, "3");

    await store.dispatch(`weChat/${WeChatActions.asyncGetMeId}`, { projid, uid });
    store.commit(`weChat/${WeChatMutations.setSelectMenu}`, "1");
    store.commit(`weChat/${WeChatMutations.setMeId}`, selectedUser.UserName);
}




return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_menu, {
      "default-active": _unref(selectMenu),
      class: "weChatMenuTabArea",
      collapse: true,
      onSelect: handleClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, { index: "1" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ChatRound))
              ]),
              _: 1
            }),
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "2" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Avatar))
              ]),
              _: 1
            }),
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "3" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Switch))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["default-active"]),
    _createVNode(_component_el_dialog, {
      class: "allUserDialog",
      modelValue: changeWeChatIdDialog.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((changeWeChatIdDialog).value = $event)),
      title: "切换账号",
      width: "500px"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(idList), (item) => {
          return (_openBlock(), _createElementBlock("div", { key: item }, [
            _createVNode(_component_el_link, {
              onClick: ($event: any) => (handleChooseId(item))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, {
                  shadow: "hover",
                  style: {"width":"400px","height":"90px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, {
                      size: 30,
                      style: {"float":"left","width":"10%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(User))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_text, { style: {"float":"right","width":"88%"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createTextVNode("NickName: " + _toDisplayString(item.NickName) + _toDisplayString(_unref(wechatIdCom) === item.UserName ? "(当前帐号)" : ""), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createTextVNode("UserName: " + _toDisplayString(item.UserName), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})